import React from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { empresa } from '../data/mock';

const Servicos = () => {
  const handleWhatsApp = (servico = '') => {
    const mensagem = servico 
      ? `Olá! Gostaria de agendar: ${servico}`
      : 'Olá! Gostaria de agendar um serviço.';
    const texto = encodeURIComponent(mensagem);
    window.open(`${empresa.contato.whatsapp_link}?text=${texto}`, '_blank');
  };

  const servicosLista = [
    { titulo: "Manutenção Preventiva", descricao: "Limpeza interna, troca de pasta térmica e otimização do sistema", preco: "A partir de R$ 80,00" },
    { titulo: "Formatação Completa", descricao: "Instalação do Windows, drivers e programas essenciais", preco: "A partir de R$ 120,00" },
    { titulo: "Upgrade de Hardware", descricao: "Instalação de SSD, memória RAM e outros componentes", preco: "A partir de R$ 100,00" },
    { titulo: "Remoção de Vírus", descricao: "Limpeza completa de malwares e proteção do sistema", preco: "A partir de R$ 90,00" },
    { titulo: "Recuperação de Dados", descricao: "Recuperação de arquivos perdidos ou corrompidos", preco: "Sob consulta" },
    { titulo: "Troca de Tela", descricao: "Substituição de telas de notebooks com garantia", preco: "A partir de R$ 350,00" },
    { titulo: "Troca de Bateria", descricao: "Baterias originais e compatíveis com reciclagem da antiga", preco: "A partir de R$ 180,00" },
    { titulo: "Conserto de Placas", descricao: "Reparo em nível de componente (BGA, reballing)", preco: "Sob consulta" }
  ];

  return (
    <div className="min-h-screen bg-slate-50">
      <section className="bg-gradient-to-r from-purple-700 via-blue-700 to-cyan-600 text-white py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold mb-4">Nossos Serviços</h1>
            <p className="text-xl opacity-90">
              Assistência técnica especializada com garantia e qualidade. Atendemos notebooks e computadores de todas as marcas.
            </p>
          </div>
        </div>
      </section>

      <section className="relative h-80 overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1768633647910-7e6fb53e5b0f?w=1920&h=600&fit=crop"
          alt="Técnicos trabalhando"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-purple-900/80 to-cyan-800/60 flex items-center">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-2xl text-white">
              <h2 className="text-4xl font-bold mb-4">Técnicos Especializados</h2>
              <p className="text-xl">
                Equipe qualificada com mais de 30 anos de experiência em manutenção e reparo de equipamentos.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
            {servicosLista.map((servico, index) => (
              <Card
                key={index}
                className="group hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-2 hover:border-purple-400"
              >
                <CardContent className="p-8">
                  <div className="w-16 h-16 bg-gradient-to-br from-purple-100 to-cyan-100 rounded-xl flex items-center justify-center mb-6 group-hover:bg-gradient-to-br group-hover:from-purple-600 group-hover:to-cyan-600 group-hover:scale-110 transition-all duration-300">
                    <span className="text-3xl">🔧</span>
                  </div>
                  
                  <h3 className="text-2xl font-bold text-slate-900 mb-3">
                    {servico.titulo}
                  </h3>
                  
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    {servico.descricao}
                  </p>
                  
                  <div className="flex items-center justify-between pt-4 border-t">
                    <span className="bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent font-bold text-lg">
                      {servico.preco}
                    </span>
                    <Button
                      size="sm"
                      className="bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700"
                      onClick={() => handleWhatsApp(servico.titulo)}
                    >
                      Agendar
                    </Button>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold text-slate-900 text-center mb-12">
              Perguntas Frequentes
            </h2>
            
            <div className="space-y-4">
              <Card className="p-6 hover:shadow-lg transition-shadow">
                <h3 className="text-lg font-bold text-slate-900 mb-3">
                  Quanto tempo demora a manutenção?
                </h3>
                <p className="text-gray-600">
                  O tempo varia conforme o serviço. Manutenções preventivas e formatações geralmente ficam prontas em 24h. 
                  Reparos mais complexos podem levar de 3 a 7 dias úteis.
                </p>
              </Card>

              <Card className="p-6 hover:shadow-lg transition-shadow">
                <h3 className="text-lg font-bold text-slate-900 mb-3">
                  Os serviços têm garantia?
                </h3>
                <p className="text-gray-600">
                  Sim! Todos os nossos serviços possuem garantia de 90 dias.
                </p>
              </Card>

              <Card className="p-6 hover:shadow-lg transition-shadow">
                <h3 className="text-lg font-bold text-slate-900 mb-3">
                  Fazem orçamento sem compromisso?
                </h3>
                <p className="text-gray-600">
                  Sim, fazemos avaliação e orçamento sem compromisso. A avaliação básica é gratuita.
                </p>
              </Card>

              <Card className="p-6 hover:shadow-lg transition-shadow">
                <h3 className="text-lg font-bold text-slate-900 mb-3">
                  Quais marcas vocês atendem?
                </h3>
                <p className="text-gray-600">
                  Atendemos todas as marcas: Dell, HP, Lenovo, Acer, Asus, Samsung, Apple (MacBook), Positivo e outras.
                </p>
              </Card>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-gradient-to-r from-purple-700 via-blue-700 to-cyan-600 text-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">
            Pronto para agendar seu serviço?
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto opacity-90">
            Entre em contato agora e receba um orçamento gratuito!
          </p>
          <Button
            size="lg"
            className="bg-white text-purple-700 hover:bg-gray-100 px-8 py-6 text-lg font-bold"
            onClick={() => handleWhatsApp()}
          >
            Agendar via WhatsApp
          </Button>
        </div>
      </section>
    </div>
  );
};

export default Servicos;
